import { render, staticRenderFns } from "./DatesEditor.vue?vue&type=template&id=1051edb9&scoped=true"
import script from "./DatesEditor.vue?vue&type=script&lang=js"
export * from "./DatesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051edb9",
  null
  
)

export default component.exports